<template>
    <div>

        <breadcrumb :routerList="[{to:'/dingd/dingdmainlist',title:'订单管理'},{title:'创建订单'}]" />
        <!---------------------------------------------------项目信息-------------------------------------------------------------------->
        <div class="h-piece nx-page" style="margin:20px">

            <!-------------------------------------------------------订单信息-------------------------------------------------------------------->
            <div class="nx-card">
                <div class="nx-card-title">
                    <span class="nx-card-bar"></span>
                    <span>订单信息</span>
                </div>
                <div class="nx-card-body">
                    <el-form label-position="top" :inline="false" ref="form0" :model="order" class="nx-form">
                        <div class="nx-grid nx-grid-3">
                            <el-form-item label="订单类型">
                                <el-input v-model="xsqyStr" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="创建人">
                                <el-input v-model="this.order.cuname" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="创建时间">
                                <el-input v-model="this.order.cdate" readonly></el-input>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
            </div>
            <!-------------------------------------------------------订单信息-------------------------------------------------------------------->

            <!-------------------------------------------------------客户信息-------------------------------------------------------------------->
            <!--两栏布局:左=客户信息/产品详情,右=产品图片/改制选项-->
            <div class="nx-layout">
                <div class="nx-card nx-cell">
                    <div class="nx-card-title">
                        <span class="nx-card-bar"></span>
                        <span>客户信息</span>
                    </div>
                    <div class="nx-card-body">
                        <el-form :model="order" ref="form1" label-position="top" :inline="false" class="nx-form nx-grid nx-grid-3">
                            <el-form-item prop="soldToName" label="售达方名称" :rules="[
								  { required: true, message: '请输入售达方名称', trigger:['change', ' blur','input']},
								]" class="h-elformWrap-2">
                                <el-input v-model="order.soldToName" placeholder="请输入" readonly>
                                    <i v-if="selectDailishang" class="el-icon-search el-input__icon" slot="suffix" @click="openShoudf">
                                    </i>
                                </el-input>
                            </el-form-item>
                            <el-form-item prop="soldToAreaName" label="售达方区域" class="h-elformWrap-2">
                                <el-input v-model="order.soldToAreaName" readonly placeholder="自带出"></el-input>
                            </el-form-item>
                            <el-form-item label="销售区域" :rules="[
								  { required: true, message: '请输入销售区域', trigger:['change', ' blur','input']},
								]" class="h-elformWrap-2">
                                <el-select v-model="order.salesregion" placeholder="请选择" @change="changeArea($event)" style="width:100%">
                                    <el-option v-for="item in salesregionNameListFilter" :key="item.code" :label="item.name" :value="item.code">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item prop="customerChannelCode" label="客户渠道" :rules="[
								  { required: true, message: '请输入客户渠道', trigger:['change', ' blur','input']},
								]" class="h-elformWrap-2">
                                <el-select v-model="order.customerChannelCode" placeholder="请选择" @change="cleanOrder($event)" style="width:100%">
                                    <el-option v-for="item in customerChannelListFilter" :key="item.code" :label="item.name" :value="item.code">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item prop="isStockUp" label="是否备货" :rules="[
								  { required: true, message: '请输入是否备货', trigger: 'change'},
								]" class="h-elformWrap-2">
                                <brselect clearable category="shifou_keyong" :v="order.isStockUp" v-model="order.isStockUp"></brselect>
                            </el-form-item>

                            <el-form-item label="收货单位" prop="toCompanyname" :clearable="true" :rules="[
								  { required: true, message: '请输入选择单位', trigger: 'blur'},
								]" v-if="!guanliren">
                                <div class="nx-field-with-icon">
                                    <el-select v-model="order.toCompanyname" remote filterable :filter-method="showFormList" style="width:100%" :v="order.toCompanyname" clearable placeholder="请输入" :remote-method="showFormList">
                                        <el-option v-for="(item) in addrList" :key="item.id" :label="item.deptName" :value="item.deptName">
                                        </el-option>
                                    </el-select>
                                    <i class="el-icon-circle-plus nx-add-icon" title="新增收货单位" @click="createAddress"></i>
                                </div>
                            </el-form-item>
                            <el-form-item label="收货单位" p :clearable="true" v-if="guanliren">
                                <div class="nx-field-with-icon">
                                    <el-select v-model="order.toCompanyname" remote filterable :filter-method="showFormList" style="width:100%" :v="order.toCompanyname" clearable placeholder="请输入" :remote-method="showFormList">
                                        <el-option v-for="(item) in addrList" :key="item.id" :label="item.deptName" :value="item.deptName">
                                        </el-option>
                                    </el-select>
                                    <i class="el-icon-circle-plus nx-add-icon" title="新增收货单位" @click="createAddress"></i>
                                </div>
                            </el-form-item>

                            <el-form-item prop="contactName" label="收货联系人" :rules="[
								  { required: true, message: '请输入收货联系人', trigger: 'blur'},
								]" class="h-elformWrap-2">
                                <el-input v-model="order.contactName" placeholder="请输入"></el-input>
                            </el-form-item>

                            <el-form-item label="选择收货地址" readonly :rules="[{ required: true, message: '请输入选择收货地址', trigger:['change', ' blur','input']},]" prop="toAddress" class="h-elformWrap-2">
                                <el-input clearable v-model="order.toAddress" readonly style="width:100%;">
                                    <i class="el-icon-search el-input__icon" slot="suffix" @click="selectAreadialog">
                                    </i>
                                </el-input>
                            </el-form-item>


                            <el-form-item label="联系电话" width="300" :rules="[
								  { required: true, message: '请输入联系电话', trigger:['change', ' blur','input']},
								  { validator: validatePhone, trigger: 'blur' }
								]" class="h-elformWrap-2" prop="firsttelephone">
                                <div class="block">
                                    <el-input v-model="order.firsttelephone" placeholder="请输入" @input="order.firsttelephone = order.firsttelephone.replace(/\s/g, '')"></el-input>
                                </div>
                            </el-form-item>

                            <el-form-item label="期望收货日期" class="h-elformWrap-2" width="100%" :rules="[
								  { required: true, message: '请先选择收货地址', trigger: 'blur'},
								]" prop="receivedTime" v-if="!guanliren">
                                <div class="block">
                                    <el-date-picker v-model="order.receivedTime" type="date" :clearable="false" value-format="yyyy-MM-dd" placeholder="--请先选择期望收货日期--">
                                    </el-date-picker>
                                </div>
                            </el-form-item>

                            <el-form-item label="交货期" class="h-elformWrap-2" v-if="isYx" width="100%" :rules="[
								  { required: true, message: '请输入交货期', trigger: 'blur'},
								]" prop="saleManName">
                                <el-input v-model="order.saleManName" placeholder="请输入"></el-input>
                            </el-form-item>

                            <el-form-item label="质保期" class="h-elformWrap-2" v-if="isYx" width="100%" :rules="[
								  { required: true, message: '请输入质保期', trigger: 'blur'},
								]" prop="saleManCode">
                                <el-input v-model="order.saleManCode" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item prop="currencyCode" label="币种" :rules="[
								  { required: true, message: '请输入币种', trigger: 'change'},
								]" class="h-elformWrap-2">
                                <mdmselect clearable category="YLCurrency" :showcode="true" disabled :v="order.currencyCode" v-model="order.currencyCode"></mdmselect>
                            </el-form-item>

                            <!-- 附件上传 -->
                            <el-form-item v-if="this.lkFlag" label="方案图纸" class="h-elformWrap-2 nx-inline" :rules="[
							  { required: true, message: '请上传方案图纸', trigger: 'change'},
							]">
                                <brupload v-model="order.fileUrl" :refid=testID reftype="施工图纸" :limit="1" :showtime="false" uploadflag delflag @filecallback=isUpload>
                                </brupload>
                            </el-form-item>
                            <el-form-item v-if="this.lkFlag" label="施工确认单" class="h-elformWrap-2 nx-inline" :rules="[
							  { required: true, message: '请上传施工确认单', trigger: 'change'},
							]">
                                <brupload v-model="order.sgFileUrl" :refid=testID reftype="NX_SGQRD" :limit="1" :showtime="false" uploadflag delflag @filecallback=sgIsUpload>
                                </brupload>
                            </el-form-item>

                            <el-form-item label="海尔标准配置" prop="isStandard" class="h-elformWrap-2" v-if="this.lkFlag" :rules="[{ required: true, message: '请选择海尔标准配置', trigger:['change', 'blur']},]">
                                <brselect clearable category="haier_standard" :v="order.isStandard" @change="isStandardChange" v-model="order.isStandard"></brselect>
                            </el-form-item>

                            <el-form-item v-if="this.lkFlag" label="投标参数" class="h-elformWrap-2 nx-inline" :rules="[
							  { required: true, message: '请上传投标参数', trigger: 'change'},
							]">
                                <brupload v-model="order.csFileUrl" :refid=testID reftype="NX_TBCS" :limit="1" :showtime="false" uploadflag delflag @filecallback=csIsUpload>
                                </brupload>
                            </el-form-item>
                            <el-form-item prop="hhxmCode" label="项目合同" v-if="isHh && !hhdls" class="h-elformWrap-2">
                                <el-select v-model="order.hhxmCode" clearable filterable @change="changeHhxmCode(order.hhxmCode)" placeholder="请选择" style="width:100%">
                                    <el-option v-for="item in hhxmList" :key="item.id" :label="item.contractName +'-'+ item.id" :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>


                            <el-form-item prop="startTime" label="质保开始时间" v-if="isHHxm" class="h-elformWrap-2" width="100%">
                                <div class="block">
                                    <el-date-picker v-model="order.startTime" type="date" :clearable="false" placeholder="--请先选择质保开始日期--" value-format="yyyy-MM-dd">
                                    </el-date-picker>
                                </div>
                            </el-form-item>
                            <el-form-item prop="endTime" label="质保结束时间" v-if="isHHxm" class="h-elformWrap-2" width="100%">
                                <div class="block">
                                    <el-date-picker v-model="order.endTime" type="date" :clearable="false" placeholder="--请先选择质保开始日期--" value-format="yyyy-MM-dd">
                                    </el-date-picker>
                                </div>
                            </el-form-item>

                            <el-form-item label="是否战略" class="h-elformWrap-2" v-if="agentLevel!=2 || hhdls">
                                <brselect clearable category="is_zhanlue" :v="order.isZl" v-model="order.isZl"></brselect>
                            </el-form-item>

                            <el-form-item v-if="agentLevel!=2 || hhdls" label="战略附件" class="h-elformWrap-2 nx-inline">
                                <brupload v-model="order.sgFileUrl" :refid=testID reftype="NX_ZLXY" :limit="1" :showtime="false" uploadflag delflag @filecallback=sgIsUpload>
                                </brupload>
                            </el-form-item>

                            <el-form-item label="管控附件" class="h-elformWrap-2 nx-inline">
                                <brupload :refid=testID reftype="管控附件" :limit="1" :showtime="false" uploadflag delflag @filecallback=sgIsUpload>
                                </brupload>
                            </el-form-item>

                            <el-form-item v-if="this.zhidanflag&&!guanliren" label="直单附件" class="h-elformWrap-2 nx-inline" required>
                                <el-upload style="margin-top: 0;" v-model="order.zmFile" class="upload-demo" action="" :http-request="httpRequest2" :on-remove="handleRemove2" :before-remove="beforeRemove" :before-upload="beforeUpload" multiple :file-list="fileList2" :auto-upload=true>
                                    <el-button size="small" type="primary">点击上传</el-button>
                                </el-upload>
                            </el-form-item>

                            <h6 class="nx-full" style="color: red;font-size: 0.14rem;margin-top: 0.1rem;" v-if="secondAgent">提货联系人、提货联系方式为售后网点提货需要联系的人员！！</h6>
                            <h6 class="nx-full" style="color: red;font-size: 0.14rem;margin-top: 0.1rem;">订单为异地发货时，必须选择是否战略以及上传战略附件！！</h6>

                        </el-form>
                    </div>
                </div>
                <!-------------------------------------------------------客户信息-------------------------------------------------------------------->

                <!-------------------------------------------------------产品信息-------------------------------------------------------------------->
                <!--产品图片(右):始终渲染,没有产品时展示空图占位,并承载唯一的「选择产品」按钮-->
                <div class="nx-card nx-cell">
                    <div class="nx-card-title">
                        <span class="nx-card-bar"></span>
                        <span>产品图片</span>
                        <div class="nx-title-right">
                            <el-button size="mini" type="primary" icon="el-icon-circle-plus" v-if="showaddProductRow" @click="showProcuct1">选择产品
                            </el-button>
                            <el-button type="text" size="mini" v-if="currentProduct" style="margin-left: 8px;" @click="imagePanelCollapsed = !imagePanelCollapsed">
                                {{ imagePanelCollapsed ? '展开图片' : '收起图片' }}
                            </el-button>
                        </div>
                    </div>
                    <div class="nx-card-body" v-show="!currentProduct || !imagePanelCollapsed">
                        <template v-if="currentProduct && (currentProduct.imageUrls || []).length > 0">
                            <div class="panel-main">
                                <el-image class="panel-image"
                                          :src="currentProduct.imageUrls[currentProduct.imageIndex || 0]"
                                          :preview-src-list="(currentProduct.previewImageUrls && currentProduct.previewImageUrls.length > 0) ? currentProduct.previewImageUrls : currentProduct.imageUrls"
                                          :initial-index="currentProduct.imageIndex || 0"
                                          fit="contain"
                                          referrerpolicy="no-referrer"
                                          @error="onProductImageError">
                                </el-image>
                                <span class="panel-tag">{{ '图片' + ((currentProduct.imageIndex || 0) + 1) }}</span>
                            </div>
                            <div class="panel-thumbs" v-if="currentProduct.imageUrls.length > 1">
                                <div class="panel-thumb" v-for="(img, i) in currentProduct.imageUrls" :key="i" :class="{ active: i == (currentProduct.imageIndex || 0) }" @click.stop="selectProductImage(currentProduct, i)">
                                    <el-image class="panel-thumb-img" :src="img" fit="cover" referrerpolicy="no-referrer" @error="onProductImageError"></el-image>
                                </div>
                            </div>
                            <div class="panel-foot">
                                <span class="panel-count">{{ (currentProduct.imageIndex || 0) + 1 }} / {{ currentProduct.imageUrls.length }}</span>
                            </div>
                        </template>
                        <div class="panel-main panel-main-empty" v-else>
                            <i class="el-icon-picture-outline"></i>
                            <span>暂无产品图片</span>
                        </div>
                    </div>
                </div>

                <!--按公司分组:产品详情(左)、改制选项(右)、该公司合计-->
                <template v-for="(obj, index) in productGroups">
                    <template v-for="(row, ri) in getProductlist(obj.code)">
                        <!--产品详情(左)-->
                        <div class="nx-card nx-cell" :key="'detail' + obj.code + ri">
                            <div class="nx-card-title">
                                <span class="nx-card-bar"></span>
                                <span>产品详情</span>
                                <div class="nx-title-right">
                                    <span class="nx-company" v-if="!chooseGscode">{{ obj.name }}</span>
                                    <el-select v-else v-model="zhidanGsCode" placeholder="请选择" size="mini" style="width: 180px; margin-right: 8px;" @change="chooseGsCode($event),$forceUpdate()">
                                        <el-option v-for="item in zhidanCompanycode" :key="item.key" :label="item.value" :value="item.key">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div class="nx-card-body">
                                <el-form label-position="top" :inline="false" class="nx-form nx-grid nx-grid-4">
                                    <el-form-item label="产品编码">
                                        <el-input :value="row.materialCode" readonly></el-input>
                                    </el-form-item>
                                    <el-form-item label="产品名称">
                                        <el-input :value="row.materialName" readonly></el-input>
                                    </el-form-item>
                                    <el-form-item label="产地">
                                        <el-input v-if="!changeFactory" :value="row.factory || '-'" readonly></el-input>
                                        <el-select v-else v-model="row.factory" placeholder="请选择">
                                            <el-option v-for="(item) in factorylist" :key="item.code" :label="item.code" :value="item.code">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="共享大类" v-if="!secondAgent">
                                        <el-select v-if="row.proType=='OEM'&&row.smList.length>0" v-model="row.shareModelCode" @change="changeShareModel($event,row)" placeholder="请选择" clearable>
                                            <el-option v-for="item in row.smList" :key="item.shareModelCode" :label="item.shareModelName" :value="item.shareModelCode">
                                            </el-option>
                                        </el-select>
                                        <el-select v-else v-model="row.shareModelCode" disabled placeholder="请选择" clearable>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="客户型号" v-if="obj.code == '44U0'">
                                        <el-input v-model="row.yidishpyj" placeholder="请输入" auto-complete="off"></el-input>
                                    </el-form-item>
                                    <el-form-item label="业务类型" v-if="guanliren">
                                        <el-select v-model="row.zhifakufa" :clearable="true" disabled placeholder="请选择">
                                            <el-option label="直发" :value="1"></el-option>
                                            <el-option label="库发" :value="2"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="订单数量">
                                        <el-input v-model="row.proNumber" placeholder="请输入" auto-complete="off" @input="onProductNumberInput(row)"></el-input>
                                    </el-form-item>
                                    <el-form-item label="基准价" v-if="!secondAgent || hhdls">
                                        <el-input :value="row.proBenchmarkPrice" readonly></el-input>
                                    </el-form-item>
                                    <el-form-item label="成交价" v-if="!secondAgent || hhdls">
                                        <el-input v-if="obj.code == '44U0'" v-model.number="row.finalPrice" placeholder="请输入" auto-complete="off" @change="change44U0finalPrice(row)"></el-input>
                                        <el-input v-else :value="calcFinalPrice(row)" readonly></el-input>
                                    </el-form-item>
                                    <el-form-item label="净价值" v-if="!secondAgent || hhdls">
                                        <el-input :value="calcNetWorth(row)" readonly></el-input>
                                    </el-form-item>
                                    <el-form-item label="总价" v-if="!secondAgent || hhdls">
                                        <el-input :value="calcTotalPrice(row)" readonly class="nx-input-total"></el-input>
                                    </el-form-item>
                                    <!--单台加价:选中改制要求的加价合计-->
                                    <el-form-item label="单台加价">
                                        <el-input :value="row.extraPrice || '0.00'" readonly class="nx-input-reform"></el-input>
                                    </el-form-item>
                                    <el-form-item label="备注" class="nx-span-2">
                                        <el-input v-model="row.note1" placeholder="请输入" auto-complete="off"></el-input>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </div>
                        <!--改制选项(右)-->
                        <div class="nx-card nx-cell nx-self-start" :key="'reform' + obj.code + ri">
                            <div class="nx-card-title">
                                <span class="nx-card-bar"></span>
                                <span>改制选项</span>
                            </div>
                            <div class="nx-card-body">
                                <el-checkbox-group v-if="(row.reformOptions || []).length > 0" class="nx-reform-group" v-model="row.reformChecked" @change="calcReformPrice(row, $event)">
                                    <el-checkbox v-for="opt in row.reformOptions" :key="opt.key" :label="opt.key">
                                        {{ opt.name }}<span class="reform-opt-price" v-if="opt.price > 0">+{{ opt.price }}</span>
                                    </el-checkbox>
                                </el-checkbox-group>
                                <div class="nx-empty" v-else>暂无改制要求</div>
                            </div>
                        </div>
                    </template>
                    <!--该公司合计-->
                    <div class="nx-full" :key="'jieguo' + index">
                        <div class="jieguo w-newIcon" v-show="!secondAgent || hhdls">
                            <span class="jieguo_label">订单总价1</span>
                            <span class="jieguo_value">{{  getOrderName(obj.code).orderPrice }}</span>
                            <span v-if="!secondAgent" class="jieguo_label">现金余额</span>
                            <span v-if="!secondAgent" class="jieguo_value">{{ getOrderName(obj.code).xianjye }}</span>
                            <span v-if="!secondAgent" class="jieguo_label">现金占用</span>
                            <span v-if="!secondAgent" class="jieguo_value">{{ getOrderName(obj.code).orderPriceXj = new big(getOrderName(obj.code).orderPrice||0).minus(getOrderName(obj.code).orderPriceXd||0).toString() }}</span>
                            <span v-if="!secondAgent" class="jieguo_label">现金欠款</span>
                            <span v-if="!secondAgent" class="jieguo_value">{{ getOrderName(obj.code).orderPriceXjQk = ((new big(getOrderName(obj.code).xianjye||0).minus(getOrderName(obj.code).orderPriceXj||0))>0 ? 0:(new big(getOrderName(obj.code).xianjye||0).minus(getOrderName(obj.code).orderPriceXj||0).toString())) }}</span>
                            <span v-if="!secondAgent" class="jieguo_label">信贷选择</span>
                            <span v-if="!secondAgent" class="jieguo_value">
                            <el-select class="ljjsales" v-model="getOrderName(obj.code).creditid" clearable placeholder="请选择" @change="creditChange($event,obj.code)">
                                <el-option v-for="item in getOrderName(obj.code).creditData" :key="item.id" :label="item.id!=null ? `信贷总额：${ item.quota }`:`请选择` " :value="item.id">
                                    <div style="color: #8492a6; font-size: 12px" v-if="item.id!=null">
                                        <i style="float: left">信贷总额：{{ item.quota }}</i>&nbsp;
                                        <i style="float: right; ">信贷截止日期：{{ item.validitydate }}</i>
                                    </div>
                                </el-option>
                            </el-select>
                        </span>
                            <span v-if="!secondAgent" class="jieguo_label">信贷占用</span>
                            <span v-if="!secondAgent" class="jieguo_value">{{getOrderName(obj.code).orderPriceXd }}</span>
                            <span class="jieguo_label">净价值</span>
                            <span class="jieguo_value">{{getOrderName(obj.code).orderNetWorth}}</span>
                        </div>
                    </div>
                </template>
            </div>
            <!-------------------------------------------------------产品信息-------------------------------------------------------------------->
            <!--------------------------------------------------------------------收货地址弹出框-------------------------------------------------------->
            <!--物料-->
            <wxwl :visible.sync="showwuliaodialog1" v-if="showwuliaodialog1" @choseObj="choseWuliao1" :usercode="order.soldToCode" :ddlx="ddlx" :xmcode="xmcode" :currencyCode="order.currencyCode" :customerChannelCode="order.customerChannelCode" :areaCode="order.salesregion" title="选择物料" />
            <!--售达方-->
            <shoudf :visible.sync="showshdfdialog" v-if="showshdfdialog" @choseObj="choseshoudf" oneflag :usercode="currentUser" :xmcode="xmcode" :ddlx="ddlx" :xszz="order.saleGroupCode" title="选择售达方" />
            <!--地址信息-->
            <areaSelect :visible.sync="showdizhiflag" v-if="showdizhiflag" @choseObj="choseDizhi" />
            <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid" />
        </div>
        <div v-if="taskstatus=='0'">
            <div class="anniu" v-if="!resubmit">
                <el-row>
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="backtolist">返回</el-button>
                    <el-button class="h-btn h-bBtn h-bggreen" @click="saveOrSubmit(10)">暂存</el-button>
                    <el-button class="h-btn h-bBtn h-bgblueQ2" @click="saveOrSubmit(20)">确认提交</el-button>
                </el-row>
            </div>
            <div class="anniu" v-else>
                <el-row>
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="backtolist">返回</el-button>
                    <el-button class="h-btn h-bBtn h-bgblueQ2" @click="resaveOrSubmit(20)">重新提交</el-button>
                    <el-button class="h-btn h-bBtn" @click="viewpress">审批跟踪</el-button>
                </el-row>
            </div>
        </div>
        <div class="anniu" v-if="taskstatus == '1'">
            <el-row>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="this.$store.dispatch('backToTaskIndex')">返回</el-button>
            </el-row>
        </div>
        <el-dialog :close-on-click-modal="false" @close='closeDialog' :visible.sync="institutionalX" class="h-dialog2">
            <companyName ref="companyName" :titleName="titleDig" :add1="add" :stVal="stVal" @getChildValue="closeCompanyName"></companyName>
        </el-dialog>
    </div>
</template>
<script>
import big from 'big.js'
import ss from '../../api/SystemService'
import wxwl from '../../components/dialog/wxwl'
import shoudf from '../../components/dialog/selectshdf'
// import the component
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import uploadFile from "../../api/process/account_complainUploadService";

import uploaddown from '../../utils/updownfile'
import reformToMaterial from '../../api/reformToMaterial/reformToMaterial'
import _ from "loadsh";
import companyName from "@/components/basic/companyName.vue";
export default {
    components: {
        companyName,
        wxwl, shoudf, Treeselect
    },
    filters: {
        gsname: function (v) {
            return _.find(this.allxszz, { code: v }).name;
        },
        numFilter (value) {
            let realVal = ''
            if (value) {
                // 截取当前数据到小数点后两位
                realVal = parseFloat(value).toFixed(2) * 100 + '%'
            } else {
                realVal = '--'
            }
            return realVal
        }
    },
    data () {
        return {
            institutionalX: false,
            orderNu: -1,
            testID: '',
            submitChongfuFlag: true,
            ydgFlag: false,
            checked: true,

            contractName: "",
            status: 1,
            toshow: 'createNxOrder2',
            resubmit: false,
            instid: null,
            taskstatus: 0,
            showhistory: false,
            selectDailishang: true,
            showwuliaodialog1: false,
            showshdfdialog: false,
            showdizhiflag: false,
            changeFactory:false,
            currentUser: null,
            showdelProductRow: true,
            showaddProductRow: true,

            //是否可以选择时间
            startDateLimit: {
                disabledDate: (time) => {
                    return time.getTime() < Date.now() + 5 * 24 * 3600 * 1000
                }
            },
            openReceivedTimedisabled: true,
            //现金余额
            cashBalance: 0,
            xmcode: null,
            //销售组织
            allxszz: [],
            //订单类型
            ddlx: null,
            //是否直单用户
            zhidanflag: 0,
            companycodes: "",
            zhidanCompanycode: [],
            isBlood: 0,
            //经销商级别(一级二级)
            agentLevel: "",
            //是否二级经销商
            secondAgent: false,
            hhdls:false,
            hhpts:false,
            hhptsName:null,
            hhGsCode:null,
            hhType:null,
            chooseGscode: false,
            xiaoshouCompany: false,
            kgsUser: false,
            zhidanGsCode: "",

            //行项目
            productlist9390: [],
            productlist9370: [],
            productlist1D90: [],
            productlist1JC0: [],
            productlist9391: [],
            productlist1RK0: [],
            productlist1R60: [],
            productlist0PN0: [],
            productlist1S00: [],
            productlist1S40: [],
            productlist1S30: [],
            productlist44U0: [],
            productlist45K0: [],
            allProductlist: [],
            //客户地址信息
            addrList: [],
            //对象
            order9390: {
                orderPrice: 0, // 订单总价
                xianjye: 0,
                taxCat: 0,
                taxRate: 0,
                orderPriceXj: 0, // 订单现金占用
                orderPriceXjQk: 0, // 订单现金欠款
                creditid: null, // 信贷id
                orderPriceXd: 0, // 订单信贷占用
                orderNetWorth: 0, // 订单净价值
                creditData: [],
            },
            order9370: {
                orderPrice: 0, // 订单总价
                xianjye: 0,
                taxCat: 0,
                taxRate: 0,
                orderPriceXj: 0, // 订单现金占用
                orderPriceXjQk: 0, // 订单现金欠款
                creditid: null, // 信贷id
                orderPriceXd: 0, // 订单信贷占用
                orderNetWorth: 0, // 订单净价值
                creditData: [],
            },
            order1D90: {
                orderPrice: 0, // 订单总价
                xianjye: 0,
                taxCat: 0,
                taxRate: 0,
                orderPriceXj: 0, // 订单现金占用
                orderPriceXjQk: 0, // 订单现金欠款
                creditid: null, // 信贷id
                orderPriceXd: 0, // 订单信贷占用
                orderNetWorth: 0, // 订单净价值
                creditData: [],
            },
            order1JC0: {
                orderPrice: 0, // 订单总价
                xianjye: 0,
                taxCat: 0,
                taxRate: 0,
                orderPriceXj: 0, // 订单现金占用
                orderPriceXjQk: 0, // 订单现金欠款
                creditid: null, // 信贷id
                orderPriceXd: 0, // 订单信贷占用
                orderNetWorth: 0, // 订单净价值
                creditData: [],
            },
            order9391: {
                orderPrice: 0, // 订单总价
                xianjye: 0,
                taxCat: 0,
                taxRate: 0,
                orderPriceXj: 0, // 订单现金占用
                orderPriceXjQk: 0, // 订单现金欠款
                creditid: null, // 信贷id
                orderPriceXd: 0, // 订单信贷占用
                orderNetWorth: 0, // 订单净价值
                creditData: [],
            },
            order1RK0: {
                orderPrice: 0, // 订单总价
                xianjye: 0,
                taxCat: 0,
                taxRate: 0,
                orderPriceXj: 0, // 订单现金占用
                orderPriceXjQk: 0, // 订单现金欠款
                creditid: null, // 信贷id
                orderPriceXd: 0, // 订单信贷占用
                orderNetWorth: 0, // 订单净价值
                creditData: [],
            },
            order1R60: {
                orderPrice: 0, // 订单总价
                xianjye: 0,
                taxCat: 0,
                taxRate: 0,
                orderPriceXj: 0, // 订单现金占用
                orderPriceXjQk: 0, // 订单现金欠款
                creditid: null, // 信贷id
                orderPriceXd: 0, // 订单信贷占用
                orderNetWorth: 0, // 订单净价值
                creditData: [],
            },
            order0PN0: {
                orderPrice: 0, // 订单总价
                xianjye: 0,
                taxCat: 0,
                taxRate: 0,
                orderPriceXj: 0, // 订单现金占用
                orderPriceXjQk: 0, // 订单现金欠款
                creditid: null, // 信贷id
                orderPriceXd: 0, // 订单信贷占用
                orderNetWorth: 0, // 订单净价值
                creditData: [],
            },
            order1S00: {
                orderPrice: 0, // 订单总价
                xianjye: 0,
                taxCat: 0,
                taxRate: 0,
                orderPriceXj: 0, // 订单现金占用
                orderPriceXjQk: 0, // 订单现金欠款
                creditid: null, // 信贷id
                orderPriceXd: 0, // 订单信贷占用
                orderNetWorth: 0, // 订单净价值
                creditData: [],
            },
            order1S40: {
                orderPrice: 0, // 订单总价
                xianjye: 0,
                taxCat: 0,
                taxRate: 0,
                orderPriceXj: 0, // 订单现金占用
                orderPriceXjQk: 0, // 订单现金欠款
                creditid: null, // 信贷id
                orderPriceXd: 0, // 订单信贷占用
                orderNetWorth: 0, // 订单净价值
                creditData: [],
            },
            order1S30: {
                orderPrice: 0, // 订单总价
                xianjye: 0,
                taxCat: 0,
                taxRate: 0,
                orderPriceXj: 0, // 订单现金占用
                orderPriceXjQk: 0, // 订单现金欠款
                creditid: null, // 信贷id
                orderPriceXd: 0, // 订单信贷占用
                orderNetWorth: 0, // 订单净价值
                creditData: [],
            },
            order44U0: {
                orderPrice: 0, // 订单总价
                xianjye: 0,
                taxCat: 0,
                taxRate: 0,
                orderPriceXj: 0, // 订单现金占用
                orderPriceXjQk: 0, // 订单现金欠款
                creditid: null, // 信贷id
                orderPriceXd: 0, // 订单信贷占用
                orderNetWorth: 0, // 订单净价值
                creditData: [],
            },
            order45K0: {
                orderPrice: 0, // 订单总价
                xianjye: 0,
                taxCat: 0,
                taxRate: 0,
                orderPriceXj: 0, // 订单现金占用
                orderPriceXjQk: 0, // 订单现金欠款
                creditid: null, // 信贷id
                orderPriceXd: 0, // 订单信贷占用
                orderNetWorth: 0, // 订单净价值
                creditData: [],
            },
            order: {
                id: null, // 主键
                orderCategory: null, // 订单类型
                orderCategory1: null, // 订单详细类型:2-标准
                saleGroupCode: null, // 销售组织编码:6200-青岛海尔生物医疗-香港销组织,9390-青岛,9391-上海,9370-青岛海特生物医疗-销售组织 1D90-海乐苗（青岛）智能物联有限公司 1JC0-青岛鸿鹄航空科技有限公司
                disChannelCode: null, // 分销渠道编码:00-通用分销渠道,X1-香港外销渠道,Z1-上海直销渠道
                zCode: null, // 分销渠道编码-子编码
                customerChannelCode: null, // 客户渠道
                isStockUp: null, // 是否备货      1：是；0：否
                orderStatus: null, // 订单状态： 10:暂存  20:审核中, 21:订单管理员通过, 22:订单管理员未通过, 23:财务经理未通过, 24:财务经理通过   30:sap已提交,31:sap待审核,32:sap已通过
                instid: null, // 流程id
                taskId: null, // 流程id
                contactName: null, // 联系人名称
                receivedTime: null, // 预计收货时间
                soldToCode: null, // 售达方编码
                soldToName: null, // 售达方名称
                salesregion: null, // 售达方销售区域
                salesregionName: null, // 售达方销售区域名称
                soldToAreaCode: null, // 售达方地区编码
                soldToAreaName: null, // 售达方地区名称
                shipToCode: null, // 送达方编码
                shipToName: null, // 送达方名称
                shipToAreaCode: null, // 送达方地区编码
                invoiceCode: null, // 开票方编码
                payerCode: null, // 付款方编码
                currencyCode: null, // 币种编码
                orderPrice: 0, // 订单总价
                orderPriceXj: 0, // 订单现金占用
                orderPriceXjQk: 0, // 订单现金欠款
                creditid: null, // 信贷id
                orderPriceXd: 0, // 订单信贷占用
                orderNetWorth: 0, // 订单净价值
                poId: null, // PO号
                areaId: null, // 区域详情表关联id
                dcCode: null, // 配送中心编码
                toProvincesCode: null, // 送达省份编码
                toCityCode: null, // 送达城市编码
                note: null, // 订单备注
                note1: null,//产品备注
                yidishpyj: null,//客户型号,元析公司使用
                postcode: null, // 邮政编码
                firsttelephone: null, // 第一个电话
                secondtelephone: null, // 第二电话
                extraPrice: null, // 定制加价
                sapsended: null, // 是否已提交sap,1-是,0-否
                toAddress: null, // 收货地址
                toCompanyname: null, // 送达方公司全称
                submitflag: null,//提交标志
                categoryName: null,
                category1Name: null,
                saleGrputName: null,
                disChannelName: null,
                zcodeName: null,
                fktj: null, //付款条件
                businessReason: null,

                lkfileUrl: null,
                fileUrl: [],
                sgFileUrl: null,
                csFileUrl: null,
                isStandard: '',
                isZl: '',
                agentLevel: "",
                zmFile: null,
                upload2: [],
                hhxmCode: null,//厚宏项目id
                startTime: null,//质保开始时间
                endTime: null,//质保结束时间
                hhdls:"0",//标记为厚宏的代理商
            },
            //产品 list
            productlist1: [],
            //客户渠道list
            customerChannelList: [],
            customerChannelListFilter: [],

            salesregionNameList: [],
            salesregionNameListFilter: [],

            lkFlag: false,
            csFlag: false,
            isHHxm: false,
            isHh: false,
            isYx: false,

            titleDig: false,
            shenglist: [],
            arealist2: [],
            arealist3: [],
            hhxmList: [],
            add: {
                id: '',
                deptName: '',
                deptType: '',
                leader: '',
                phone: '',
                email: '',
                status: '',
                countryId: '',
                country: '',
                provinceId: '',
                province: '',
                cityId: '',
                city: '',
                areaId: '',
                landmark: '',
                area: '',
                shengobj: '',
                shiobj: '',
                quobj: '',
                selectId: '',
                address: '',
                subFlag: '',
                deptSourceChannel: '',
                longitude: '',
                latitude: '',
                parentCode: '',
                schoolTypeName: '',
            },
            proSelect: {
                pcode: 0,
                level: 1,
            },
            rules: {
                fileUrl: [
                    { required: true, message: '请上传方案图纸', trigger: 'blur' }
                ],
                sgFileUrl: [
                    { required: true, message: '请上传施工确认单', trigger: 'blur' }
                ],
                csFileUrl: [
                    { required: true, message: '请上传投标参数', trigger: 'blur' }
                ]
            },
            deptNameList: [],
            addressTypeList: [],
            options: [],
            stVal: null,
            reftype2: 'NX_ZMFJ',
            fileList2: [],
            idList: [],
            showCollage: false,
            //所用公司信息
            companyInfoList: [],
            //产地
            factorylist:[{code:"1S00"},{code:"1S40"},{code:"1S30"}],
            guanliren: false,
            showXietong: true,
            //产品图片缓存:materialCode -> 图片地址列表
            productImageCache: {},

            currentRowId: null,
            imagePanelCollapsed: false,

        }
    },

    //页面加载前事件
    created () {
        //所用公司信息
        this.companyInfoList = this.$store.getters.dictlist("company_info");
        // 当前权限
        this.guanliren = this.$store.getters.hasRole("swyl_xiaoshoujl_yx,yx_shouhoujl");

        this.kgsUser = this.$store.getters.hasRole("swyl_hh_kgs");

        this.showXietong = this.$store.getters.hasRole("swyl_gndailishang,swyl_gwdailishang,swyl_xiaoshoujl,swyl_xiaoshoujl_wx,swyl_dingdgly,swyl_waixiaogly");

        //生产所有公司产品变量
        this.companyInfoList.forEach((obj) => {
            this.$set(this.allProductlist, 'productlist' + obj.code, [])
            //动态生成监听
            this.$watch('productlist' + obj.code, (newValue, oldValue) => {

                //计算总金额
                this['order' + obj.code].orderPrice = _.reduce(_.map(newValue, "totalprice"), function (sum, v) {
                    return new big(sum).plus(v || 0).toString();
                }, 0)
                //计算总净价值
                this['order' + obj.code].orderNetWorth = _.reduce(_.map(newValue, "jinejjz"), function (sum, v) {
                    return new big(sum).plus(v || 0).toString();
                }, 0)
                //重新计算信贷
                if (this['order' + obj.code].creditid) {
                    this.creditChange(this['order' + obj.code].creditid, obj.code);
                }
            }, { deep: true, immediate: true });

        })

        if (this.$route.query.id == '' || this.$route.query.id == undefined) {
            this.testID = this.$route.query.ywid
        } else {
            this.testID = this.$route.query.id
        }
        this.order.fileUrl = []
        this.order.sgFileUrl = []
        this.order.csFileUrl = []
        console.log('我在这儿呀', this.$route.query.chongXinTiJiao);

        this.allxszz = this.$store.getters.dictlist('YLSalesOrganization_agent');
        this.customerChannelList = this.$store.getters.dictlist("sales_region");
        this.salesregionNameList = this.$store.getters.dictlist("YlSalesArea_chanpin");
        let id = this.$route.query.ywid;
        console.log(this.testID)
        let instid = this.$route.query.instid;
        let taskid = this.$route.query.taskid;
        let taskstatus = this.$route.query.taskstatus | 0;
        let chongXinTiJiao = this.$route.query.chongXinTiJiao;
        //代办打开的
        if (id && instid) {
            this.resubmit = true;
            //如果不是重新提交,则不能添加跟删除了
            if (!chongXinTiJiao) {
                this.showaddProductRow = false;
                this.showdelProductRow = false;
            }

            this.instid = instid;
            this.taskstatus = taskstatus;
            this.order.taskId = taskid;
            if (taskstatus == '1') {
                // 直接设置经销商
                this.selectDailishang = false;
                const parent = document.querySelector(".input");
                parent.className = "input el-input ";//改变父集的class,把父集改成可编辑状态，
                //2.在设置input属性
                //获取input
                const input = document.querySelector(".input input");
                //设置input的属性为false
                input.disabled = false;
            }
        }
        if (this.$route.query.agentLevel == 2) {
            this.getSecondOrder(id || this.$route.query.id);
        } else {
            if (this.$route.query.zltype == '3') {
                this.getOrderZl(this.$route.query.id);
            } else {
                this.getOrder(id || this.$route.query.id);
            }
        }

        // this.order.customerChannelCode = null;
        this.getParentInfo();

        //判断能否显示价格信息
        //如果不是内部用户 并且 agentLevel=2
        if (this._user.usertype != '0' && this._user.agentLevel == 2) {
            //判断是否是分销商（二级经销商）
            this.secondAgent = true;
        }
        //是不是其他公司的销售经理
        if (this.$store.getters.hasRole('swyl_xiaoshoujl_kangsheng') || this.$store.getters.hasRole('swyl_admin')
            || this.$store.getters.hasRole('swyl_xiaoshoujl_hsj')
        ) {
            this.xiaoshouCompany = true;
        }


    },

    computed: {
        xsqyStr () {
            if (this.order.category2Name) {
                return this.order.categoryName + "/" + this.order.category1Name + "/" + this.order.category2Name
            } else if (this.order.category1Name) {
                return this.order.categoryName + "/" + this.order.category1Name
            }
            return this.order.categoryName
        },
        //有产品的公司:布局按公司分组渲染,无产品的公司不展示
        productGroups () {
            return this.companyInfoList.filter((obj) => {
                return (this['productlist' + obj.code] || []).length > 0;
            })
        },
        //当前产品:没有选择产品时返回 null(产品图片卡片据此展示空图占位)
        currentProduct () {
            for (var i = 0; i < this.companyInfoList.length; i++) {
                var list = this['productlist' + this.companyInfoList[i].code] || [];
                if (list.length > 0) {
                    return list[0];
                }
            }
            return null;
        }
    },
    watch: {
        //原逻辑删除mark


    },
    mounted () {

    },
    beforeDestroy () {
        //释放产品图片大图预览占用的 blob 内存
        var all = [];
        this.companyInfoList.forEach((obj) => {
            all = all.concat(this['productlist' + obj.code] || []);
        })
        all.forEach((row) => {
            (row.previewImageUrls || []).forEach((url) => {
                if (url.indexOf('blob:') == 0) {
                    URL.revokeObjectURL(url);
                }
            });
        })
    },
    methods: {
        //联系方式校验
        validatePhone(rule, value, callback) {
            if (!value) {
                callback();
                return;
            }
            if (value.includes('-')) {
                if (!/^(\d+(?:-\d+)*)$/.test(value)) {
                    callback(new Error('请输入正确的电话号码'));
                    return;
                }
            } else {
                if (!/^\d{11}$/.test(value)) {
                    callback(new Error('手机号码必须为11位数字'));
                    return;
                }
            }
            callback();
        },


        // 地图选点 弹出
        mapHandleShow () {
            this.mapDialogVisible = true;
            // this.$nextTick(() => {
            //   this.$refs.mapSrcVue.init(id)
            // })
        },
        choseMapShow (objs) {
            console.log("关闭地图11", objs)
            this.add.address = objs.address;
            this.add.deptName = objs.title;
            this.add.province = objs.province;
            this.add.city = objs.city;
            this.add.area = objs.district;
            this.add.longitude = objs.lng;
            this.add.latitude = objs.lat;
            this.loadArea();
            this.mapDialogVisible = false;
        },
        getQueryVariable (variable) {//获取参数id
            var query = window.location.search.substring(1);
            var vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                if (pair[0] == variable) { return pair[1]; }
            }
            return (false);
        },
        isUpload (v) {
            console.log(v)
            if (v.length > 0) {
                //this.order.fileUrl = v[0].saveurl;
                let arrnew = []
                v.forEach(e => {
                    arrnew.push(e.saveurl)
                })
                console.log(arrnew)
                this.order.fileUrl = arrnew
                console.log(this.order.fileUrl)
            } else {
                this.order.fileUrl = []
            }
        },
        sgIsUpload (v) {
            console.log('sgIsUpload', v)
            if (v.length > 0) {
                //this.order.fileUrl = v[0].saveurl;
                let arrnew = []
                v.forEach(e => {
                    arrnew.push(e.saveurl)
                })
                console.log(arrnew)
                this.order.sgfileUrl = arrnew
                console.log(this.order.sgfileUrl)
            } else {
                this.order.sgfileUrl = []
            }
        },
        csIsUpload (v) {
            console.log('csIsUpload', v)
            if (v.length > 0) {
                //this.order.fileUrl = v[0].saveurl;
                let arrnew = []
                v.forEach(e => {
                    arrnew.push(e.saveurl)
                })
                console.log(arrnew)
                this.order.csfileUrl = arrnew
                console.log(this.order.csfileUrl)
            } else {
                this.order.csfileUrl = []
            }
        },
        fileBack1 (v) {
            console.log(v)
            this.order.uploadFile = v.length;
        },
        //测试是否包含
        getNumber () {
            console.log(this.order)
            ss.OrderMainService.uploadCheck(this.order).then(res => {
                this.orderNu = res
            })
        },
        testDate () {
            var data = this.order
            console.log(this.order)
            ss.OrderMainService.checkDeliveryDay(data).then(res => {
                console.log(res)
                if (res.f == true) {
                    console.log(res)
                } else {
                    this.$message.error(res.msg);
                }
            })

        },
        //物流所需时间
        openReceivedTimefocus () {
            if (!this.openReceivedTimedisabled) {
                this.$msg.msge("请先选择的收货地址!");
            }
        },

        getSecondOrder (id) {
            ss.SecondOrderMainService.selectSecondOrderById(id).then(rd => {
                _.assign(this.order, rd.obj)
                this.ddlx = this.order.orderCategory + "," + (this.order.orderCategory1 || '');
                let type = this.order.orderCategory1;
                // 判断是否是经销商,经销商自己下单
                //当前登录人，就是经销商的话
                if (this._user.usertype == '1') {
                    this.order.soldToCode = this._user.usercode;
                    this.selectDailishang = false;
                }
                Promise.all([this.getShoudafang(this.order.soldToCode)]).then(() => {
                    //存在行项目
                    if (rd.obj.products && rd.obj.products.length > 0) {

                        rd.obj.products.forEach((obj) => {
                            if (obj) {
                                this.addProject(obj)
                            }
                            //判断是否冷库
                            ss.waixiao.isLk(obj.materialCode).then(rd => {
                                this.lkFlag = rd.msg;
                                console.log("lkFlag", this.lkFlag)
                            })
                        })

                    }
                    if (rd.obj.isStandard == 2) {
                        this.csFlag = true;
                    }
                })
            })
        },
        getOrder (id) {
            ss.OrderMainService.selectById(id).then(rd => {
                _.assign(this.order, rd.obj)
                this.ddlx = this.order.orderCategory + "," + (this.order.orderCategory1 || '');
                // 判断是否是经销商,经销商自己下单
                //当前登录人，就是经销商的话
                if (this._user.usertype == '1') {
                    this.order.soldToCode = this._user.usercode;
                    this.selectDailishang = false;
                }
                Promise.all([this.getShoudafang(this.order.soldToCode)]).then(() => {
                    //存在行项目
                    if (rd.obj.products && rd.obj.products.length > 0) {
                        //加载完现金跟信贷，在插入行项目
                        Promise.all(this.companyInfoList.map((val, index) => { return this.getCredit(val.code) })).then(() => {
                            rd.obj.products.forEach((obj) => {
                                if (obj) {
                                    this.addProject(obj)
                                    //如果是直单经销商，获取附件
                                    if (this.zhidanflag == '1') {
                                        uploaddown.listdownfile({ refid: obj.id, reftype: "NX_ZMFJ" }).then(rd => {
                                            this.fileList2 = rd.obj;
                                            this.idList.push(rd.obj.id);
                                            this.order.upload2.unshift("1");
                                        })
                                    }
                                }
                                //判断是否冷库
                                ss.waixiao.isLk(obj.materialCode).then(rd => {
                                    this.lkFlag = rd.msg;
                                    console.log("lkFlag", this.lkFlag)
                                })
                            })
                            //重新计算信贷
                            this.companyInfoList.forEach((obj) => {
                                if (this['order' + obj.code].creditid) {
                                    this.creditChange(this['order' + obj.code].creditid, obj.code);
                                }
                            })
                        })
                    }
                    if (rd.obj.isStandard == 2) {
                        this.csFlag = true;
                    }
                })
                //根据销售区域带出客户渠道
                console.log(" this.order.salesregion", this.order.salesregion)
                this.order.salesregion = rd.obj.salesregion
                let value = {
                    usercode: this.order.soldToCode,
                    areaCode: rd.obj.salesregion,
                }
                ss.OrderMainService.getChannelByArea(value).then(rd => {
                    console.log(rd);
                    this.customerChannelListFilter = rd.msg;
                    console.log(this.salesregionNameListFilter)
                    if (this.customerChannelListFilter.length > 0) {
                        //    this.order.customerChannelCode = null;
                    } else {
                        this.order.salesregion = null;
                        this.order.customerChannelCode = null;
                    }
                })
            })
        },
        viewpress (r) {
            this.showhistory = true;
        },
        backtolist () {
            this.$router.go(-1);
        },
        saveOrSubmit (v) {
            this.order.orderStatus = v
            if (v == '10') {
                this.order.submitflag = '暂存'
                this.order.newId = null
            } else if (v == '20') {
                this.order.submitflag = '提交'
                this.order.newId = null
            } else if (v == '30') {
                this.order.orderStatus = 20;
                this.order.newId = this.$route.query.ywid
                this.order.submitflag = '重新提报'
            }

            if(this.zhidanflag == '1'){
                if (this.zhidanGsCode == '') {
                    this.$msg.msge("产品请选择销售公司！");
                    return;
                }
            }

            if (!this.guanliren) {
                if (this.zhidanflag == '1') {
                    if (this.fileList2.length < 1 && this.zhidanGsCode != '1R60' && this.zhidanGsCode != '44U0' && this.zhidanGsCode != '45K0') {
                        this.$msg.msge("直单用户下单必须上传直单附件！");
                        return;
                    }
                }
            }
            //提交/重新提报时校验订单数量:必须填写且不能为0(暂存不校验)
            if (this.order.submitflag == '提交' || this.order.submitflag == '重新提报') {
                var invalidProduct = null;
                for (var p = 0; p < this.companyInfoList.length; p++) {
                    var productList = this['productlist' + this.companyInfoList[p].code] || [];
                    invalidProduct = _.find(productList, (item) => {
                        return item.proNumber == null || item.proNumber === '' || Number(item.proNumber) <= 0;
                    });
                    if (invalidProduct) {
                        break;
                    }
                }
                if (invalidProduct) {
                    this.$msg.msge("产品【" + (invalidProduct.materialName || invalidProduct.materialCode) + "】的订单数量必须大于0！");
                    return;
                }
            }

            var flag = true;
            //每次提交或者暂存将值清零 防止累加 hyl
            this.order.orderPrice = 0;
            this.order.orderPriceRbm = 0;


            this.companyInfoList.forEach((obj) => {
                _.forEach(this['productlist' + obj.code], (value) => {
                    value.xdid = this['order' + obj.code].creditid
                    value.totalpricermb = value.totalprice;
                    value.costCenter = this.order['costCenter' + obj.code];

                    this.order.orderPrice = new big(this.order.orderPrice || 0).plus(value.totalprice || 0);
                    this.order.orderPriceRbm = new big(this.order.orderPriceRbm || 0).plus(value.totalprice || 0);


                    //如果是分销商（二级经销商）成交价,净价值,计算总价 hyl
                    if (this.secondAgent == true || this.order.hhdls == "1") {
                        value.finalPrice = new big(value.specialPrice || value.expoPrice || value.proBenchmarkPrice * value.discount || value.proBenchmarkPrice).plus(value.extraPrice || 0).toFixed(2).toString()
                        value.jinejjz = new big(value.finalPrice).div(value.taxRate).toFixed(2).toString()
                        value.totalprice = new big(value.proNumber || 0).times((value.finalPrice || 0)).toFixed(2).toString()
                    }
                });
            })

            //计算所有订单现金占用
            this.order.orderPriceXj = this.companyInfoList.reduce((total, item) => {
                return new big(total).plus(new big(this['order' + item.code].orderPriceXj || 0)).toString();
            }, 0)
            //计算所有订单信贷占用
            this.order.orderPriceXd = this.companyInfoList.reduce((total, item) => {
                return new big(total).plus(new big(this['order' + item.code].orderPriceXd || 0)).toString();
            }, 0)
            //计算所有订单净价值
            this.order.orderNetWorth = this.companyInfoList.reduce((total, item) => {
                return new big(total).plus(new big(this['order' + item.code].orderNetWorth || 0)).toString();
            }, 0)
            //合并所有订单list
            this.order.products = [];
            this.companyInfoList.forEach((obj) => {
                this.order.products = this.order.products.concat(this['productlist' + obj.code]);
            })

            if (flag) {
                if (this.order.submitflag == '提交' || this.order.submitflag == '重新提报') {
                    this.$refs['form1'].validate((valid1) => {
                        if (valid1) {
                            this.$msg.confirm("确认提交？", () => {
                                console.log(this.order)
                                this.submitForm();
                            })
                        } else {
                            this.$msg.msge("请完善基本信息后提交");
                            return;
                        }
                    });
                } else {
                    this.submitForm();
                }
            }

        },
        submitForm () {
            if (this.submitChongfuFlag) {
                console.log(this.order)
                //检测是否需要上传附件
                ss.OrderMainService.uploadCheck(this.order).then(res => {
                    this.orderNu = res
                    if (this.orderNu == 1 && this.order.isStandard == 1) {
                        this.$message.error('此产品为冷库产品，请上传方案图纸和施工确认单');
                    } else if (this.orderNu == 1 && this.order.isStandard == 2) {
                        this.$message.error('此产品为冷库产品，请上传方案图纸,施工确认单和投标参数');
                    } else {
                        ss.OrderMainService.checkDeliveryDay(this.order).then(res => {
                            console.log(res)
                            if (res.f == true) {
                                console.log(res)
                                this.submitChongfuFlag = false;
                                ss.OrderMainService.saveOrSubmit(this.order).then(rd => {
                                    this.submitChongfuFlag = true;
                                    if (rd.f) {
                                        if (this.order.submitflag == '提交' || this.order.submitflag == '重新提报') {
                                            this.$msg.msgs("提交成功！")
                                            //二级经销商订单条二级经销商页面
                                            if (this.agentLevel == 2 || (this.hhdls && this.order.hhdls == "1")) {
                                                this.$router.push({ path: '/dingd/secondDingdmainlist' })
                                            } else {
                                                this.$router.push({ path: '/dingd/dingdmainlist' })
                                            }

                                        } else {
                                            this.$msg.msgs("暂存成功！")
                                        }
                                    } else {
                                        this.$msg.msge(rd.msg);
                                    }
                                })
                            } else {
                                this.$message.error(res.msg);
                            }
                        })
                    }

                })
            } else {
                this.$msg.msge("重复点击提交，请稍后操作！");
            }
        },
        resaveOrSubmit (v) {
            this.saveOrSubmit(30);
            // this.order.orderStatus = v
            // this.$msg.confirm("确认提交？", () => {
            //     this.order.submitflag = '重新提报'
            //     ss.OrderMainService.saveOrSubmit(this.order).then(rd => {
            //         this.$router.push({path: '/dingd/dingdmainlist'})
            //     })
            // })
        },
        getShoudafang (usercode) {
            if (!usercode) {
                if(this.guanliren){
                    this.order.receivedTime = this.$util.formatDate(this.$util.addDays(new Date(), 5))
                }
                return "";
            }
            return ss.selectUserAgent.getOneShoudf(this.order.soldToCode).then(rd => {
                this.choseshoudf(rd, true);
            })
        },
        //查询用户，用户余额，所有信贷
        getCredit (gscode) {
            var params = {};
            // console.log(this['productlist' + gscode])
            // console.log(_.map(this['productlist' + gscode], "proModelCode"))
            //列表中的第一个的产品大类
            var cpdl = _.uniq(_.map(this['productlist' + gscode], "proModelCode"));
            if (cpdl.length == 1) {
                params.cpdlcode = cpdl[0];
            }
            params.salegroupcode = gscode;
            params.usercode = this.order.soldToCode;
            // console.log(params)
            return ss.OrderMainService.getUserMoneyCredit(params).then(rd => {
                // console.log("信贷", rd)
                this['order' + gscode].creditData = rd.xd;
                this['order' + gscode].xianjye = rd.xj ? (rd.xj.cashBalance || 0) : 0;
            })
        }
        ,
        // 选择具体的信贷
        creditChange (v, gscode) {
            console.log("默认选中信贷", v, gscode)
            if (v) {
                var orderje = this['order' + gscode].orderPrice;
                var xd = _.find(this['order' + gscode].creditData, { id: v })
                var xdye = xd.quota;
                //用户的现金余额
                var xjye = this['order' + gscode].xianjye;
                if (xjye > 0) {
                    if (xjye >= orderje) {
                        this['order' + gscode].creditid = null;
                        this['order' + gscode].orderPriceXd = 0;
                    } else {
                        //现金+信贷>订单金额
                        if (xdye + xjye > orderje) {
                            this['order' + gscode].orderPriceXd = orderje - xjye;
                        } else {
                            if (orderje - xjye < xdye) {
                                this['order' + gscode].orderPriceXd = orderje - xjye;
                            } else {
                                this['order' + gscode].orderPriceXd = xdye;
                            }
                        }
                    }
                } else {
                    //信贷金额，大于订单总额
                    if (xdye >= orderje) {
                        this['order' + gscode].orderPriceXd = orderje;
                    } else {
                        //订单减掉现金余额
                        this['order' + gscode].orderPriceXd = xdye;
                    }
                }
            } else {
                this['order' + gscode].creditid = null;
                this['order' + gscode].orderPriceXd = 0;
            }
        },
        //修改共享大类
        changeShareModel (scode, row) {
            console.log(scode);
            if (row.shareModelCode) {
                const smobj = _.find(row.smList, { shareModelCode: row.shareModelCode })
                row.shareModelName = smobj.shareModelName;
                console.log(row.shareModelName);
            } else {
                row.shareModelName = null;
            }
        },
        changeArea (query) {
            console.log("接受到的参数", query);
            //根据选择的销售区域带出对应的渠道

            let value = {
                usercode: this.order.soldToCode,
                areaCode: query
            }
            ss.OrderMainService.getChannelByArea(value).then(rd => {
                console.log(rd);
                this.customerChannelListFilter = rd.msg;
                console.log(this.salesregionNameListFilter)
                if (this.customerChannelListFilter.length > 0) {
                    //    this.order.customerChannelCode = null;
                } else {
                    this.showshdfdialog = false
                    this.$msg.msge("该售达方没有维护客户渠道信息，请联系管理员！")
                    return;
                }
            })
            this.companyInfoList.forEach((obj) => {
                this['productlist' + obj.code] = [];
            })
            this.order.customerChannelCode = '';
        },
        //清空已选产品列表
        cleanOrder () {
            console.log('客户渠道发生变化!')
            this.companyInfoList.forEach((obj) => {
                console.log("obj", obj);
                this['productlist' + obj.code] = [];
            })
        },

        //选择售达方
        openShoudf () {
            this.showshdfdialog = true;
        },
        choseshoudf (obj, changeflag) {

            console.log('1234-->', obj)

            //直单用户flag
            this.zhidanflag = obj.zhidanflag;
            this.companycodes = obj.companycodeBas;
            this.isBlood = obj.isBlood;
            //是否直单用户根据签约的公司进行选择
            this.zhidanCompanycode = [];
            this.zhidanGsCode = '';
            //设置经销商级别
            this.agentLevel = obj.agentLevel;
            this.order.agentLevel = obj.agentLevel;
            //是否直单用户并且内销标准订单 可选择公司
            console.log("类型", this.ddlx);
            if (this.zhidanflag == '1' || this.kgsUser) {
                this.chooseGscode = true;
                //判断当前用户可选择的公司
                this.companyInfoList.forEach((obj) => {
                    if (this.companycodes.indexOf(obj.code) != -1) {
                        this.zhidanCompanycode.push({
                            key: obj.code,
                            value: obj.name
                        });
                        this.zhidanGsCode = obj.code
                    }
                })

                //0HL0 特殊处理
                if (this.companycodes.indexOf("0HL0") != -1) {
                    this.zhidanCompanycode.push({
                        key: "9370",
                        value: "青岛海尔生物医疗科技有限公司(9370)"
                    });
                }
                this.zhidanGsCode = ''

                //如果都没签约9370或9390或1D90或1JC0或1RK0 提示错误
                if (this.companycodes.length <= 0) {
                    this.showshdfdialog = false
                    this.$msg.msge("该直单用户没有签约公司，请联系管理员！")
                    return;
                }

                //厚宏的可以调整产地
                if(this.kgsUser){
                    this.changeFactory = true;
                }
            } else {
                this.chooseGscode = false;
            }
            console.log("公司代码：" + this.companycodes);
            console.log("是否血站渠道：" + this.isBlood);
            console.log("订单主数据", this.order);
            this.salesregionNameListFilter = _.filter(this.salesregionNameList, (o) => {
                return _.split(obj.salesregion || '', ",").includes(o.code);
            });
            // 清空物料
            if (this.order.soldToCode != obj.usercode) {
                this.companyInfoList.forEach((obj) => {
                    this['productlist' + obj.code] = [];
                })
            }
            this.order.soldToName = obj.username;
            this.order.soldToCode = obj.usercode;
            this.order.soldToAreaCode = obj.area;
            this.order.soldToAreaName = obj.areaname;
            this.order.gjmytk = obj.gjmytk; //国际贸易条款
            this.order.fktj = obj.fktj; //付款条件
            this.order.currencyCode = (changeflag ? this.order.currencyCode : obj.currency) || 'CNY';
            this.showshdfdialog = false;

            if((obj.hhType == 1 || obj.hhType == 2) && !this.kgsUser){
                this.hhdls = true;
                this.order.hhdls = obj.hhType;
                this.hhType = obj.hhType;
                this.hhGsCode = obj.hhGsCode;
                if(obj.usercode == obj.hhPtsCode){
                    this.hhpts = true;
                }
                if(obj.hhType == 1){
                    this.secondAgent = true
                    this.hhptsName = obj.hhPtsA;
                    this.companyInfoList.forEach((val) => {
                        if(val.code == '1S00' || val.code == '1S40' || val.code == '1S30'){
                            val.name = obj.hhPtsA
                        }
                    })
                }
            }else {
                if(obj.usercode == obj.hhPtsCode){
                    this.hhpts = true;
                }
            }

            // this.order.customerChannelCode = null;
        },
        //
        deleteThis (row) {

            console.log(row, "删除");
            var id = row.id;
            var gscode = row.gscode;
            this.$msg.confirm("确认删除？", () => {
                //释放被删行大图预览占用的 blob 内存
                (row.previewImageUrls || []).forEach((url) => {
                    if (url.indexOf('blob:') == 0) {
                        URL.revokeObjectURL(url);
                    }
                });
                this['productlist' + gscode] = _.reject(this['productlist' + gscode], { 'id': id });
                //合并所有订单list
                this.order.products = [];
                this.companyInfoList.forEach((obj) => {
                    this.order.products = this.order.products.concat(this['productlist' + obj.code]);
                })

                //删掉的正好是当前查看项时,回退到第一行
                if (id == this.currentRowId) {
                    var first = this.order.products.length > 0 ? this.order.products[0] : null;
                    this.currentRowId = first ? first.id : null;
                }
            })


        },
        //选择物料删除该行项目产品信息
        //选择物料
        showProcuct1 () {
            if (!this.order.soldToCode) {
                this.$msg.msge("请先选择售达方信息！")
                return;
            }
            if (!this.order.salesregion) {
                this.$msg.msge("请先选择销售区域！")
                return;
            }
            if (!this.order.customerChannelCode) {
                this.$msg.msge("请先选择客户渠道！")
                return;
            }

            this.showwuliaodialog1 = true;
        },
        //选择物料
        choseWuliao1 (objs) {
            console.log("选中的物料", objs)
            this.showwuliaodialog1 = false;
            //一个订单只允许一个产品:重新选择时覆盖原有产品
            this.companyInfoList.forEach((obj) => {
                this['productlist' + obj.code] = [];
            })
            this.currentRowId = null;
            for (var i = 0; i < objs.length; i++) {
                var addwl = objs[i];
                var wl = this.wlToProject(addwl);
                if(this.kgsUser && this.zhidanflag != '1'){
                    if(wl.factory != "1S00" && wl.factory != "9370" && wl.factory != "1S40" && wl.factory != "1S30"
                        && wl.factory != "9393" && wl.factory != "1RK0"){
                        this.$msg.msge("只可选择产地为1S00,9370,9393,1RK0,1S40,1S30的产品！");
                        return;
                    }
                    if(null != this.zhidanGsCode && this.zhidanGsCode != ''){
                        wl.gscode = this.zhidanGsCode;
                    }
                }
                //添加行项目
                this.addProject(wl);
                var lkData = wl.materialCode;
                //判断选中的产品是否是冷库产品
                ss.waixiao.isLk(lkData).then(rd => {
                    this.lkFlag = rd.msg;
                    console.log("lkFlag", this.lkFlag)
                    //如果是冷库产品,则在新增时需先生成一个虚拟的预测单号用于绑定附件,点击预测单提交时更新绑定真实的预测单编号
                })
            }
            //获取遍历公司调用getCredit方法
            Promise.all(this.companyInfoList.map((val, index) => { return this.getCredit(val.code) })).then(() => {
                this.companyInfoList.forEach((obj) => {
                    this['order' + obj.code].creditid = this['order' + obj.code].creditData.length > 0 ? _.first(this['order' + obj.code].creditData).id : null;
                    this['order' + obj.code].orderPriceXd = 0;
                })
            })

        },
        addProject (obj) {
            console.log("oooobbbbjjjj", obj);
            console.log(obj.id + "行项目");
            var alllist = []
            //合并所有订单list
            this.companyInfoList.forEach((obj) => {
                alllist = alllist.concat(this['productlist' + obj.code]);
            })

            console.log("alllist", alllist)

            // 不是直单的用户，如果下液氮罐的话，必须单独下单
            if (this.zhidanflag != '1' && obj.proModelCode == 'ND1') {
                // 看看产品列表里有没有其他产品
                for (var i = 0; i < alllist.length; i++) {
                    var one = alllist[i];
                    if (one.proModelCode != 'ND1') {
                        this.$msg.msge("液氮罐系列产品不能跟其他产品一起下单，请单独下单！");
                        return;
                    }
                }
            }
            if (this.zhidanflag != '1' && obj.proModelCode != 'ND1') {
                // 看看产品列表里有没有其他产品
                for (var i = 0; i < alllist.length; i++) {
                    var one = alllist[i];
                    if (one.proModelCode == 'ND1') {
                        this.$msg.msge("液氮罐系列产品不能跟其他产品一起下单，请单独下单！");
                        return;
                    }
                }
            }

            if (!this.order['costCenter' + obj.gscode]) {
                this.order['costCenter' + obj.gscode] = obj.costCenter || null;
            }

            this['productlist' + obj.gscode].push(obj);
            this['order' + obj.gscode].creditid = obj.xdid;
            console.log("this['productlist' + obj.gscode]", this['productlist' + obj.gscode])
            //如果1S00公司
            if ((obj.gscode == '1S00' || obj.gscode == '1S40' || obj.gscode == '1S30') && this.hhxmList.length == 0 && (this.ddlx == '1,2' || this.ddlx == '1,11')) {
                this.isHh = true;
                //查询厚宏项目合同
                ss.contractService.getHhxmContract(this.order.soldToCode).then(rd => {
                    this.hhxmList = rd.msg;
                })
            }
            //如果是44u0和45k0
            if(obj.gscode == '44U0' || obj.gscode == '45K0'){
                this.isYx = true;
            }
            //加载改制要求
            this.loadReform(obj);

            //加载产品图片
            this.loadProductImage(obj);

        },
        //产品图片统一从 imageUrls 字段获取,兼容字符串数组/对象数组/逗号分隔字符串三种返回形态
        normalizeImageUrls (raw) {
            if (!raw) {
                return [];
            }
            var list = [];
            if (Array.isArray(raw)) {
                list = raw;
            } else if (typeof raw == 'string') {
                list = raw.split(',');
            }
            var urls = [];
            list.forEach((item) => {
                if (!item) {
                    return;
                }
                var url = typeof item == 'string'
                    ? item
                    : (item.imageUrl || item.image_url || item.url || item.imagePath || item.path || '');
                url = this.formatProductImage(url);
                if (url) {
                    urls.push(url);
                }
            })
            return urls;
        },
        //加载改制要求:改制信息随产品图片接口一并返回,兼容单独的改制要求查询接口
        loadReform (row) {
            if (!row || !row.materialCode) {
                return;
            }
            //先初始化改制字段,未查询到改制要求时提交字段依然存在
            this.useReformList(row, []);
            //根据物料编码查询改制要求
            reformToMaterial.queryReformByMaterialCode({materialCode: row.materialCode}).then(rd => {
                this.useReformList(row, rd && rd.obj ? rd.obj : []);
            }).catch(() => {});

        },

        //组装改制复选框选项:改制要求(specificReform)为选项名,改制目录的单台加价(reformPrice)为选项价格
        buildReformOptions (list) {
            var options = [];
            var seen = {};
            (list || []).forEach((item, idx) => {
                if (item == null) {
                    return;
                }
                var rawName = typeof item == 'string' ? item : item.specificReform;
                var name = String(rawName == null ? '' : rawName).trim();
                if (!name) {
                    return;
                }
                //同名改制要求只保留一条,避免重复累加加价
                if (seen[name]) {
                    return;
                }
                seen[name] = true;
                var price = typeof item == 'string' ? 0 : item.reformPrice;
                //保留改制要求id,提交订单时使用
                var itemId = typeof item == 'string' ? null : (item.id == null ? null : item.id);
                var key = itemId == null ? ('reform_' + idx) : itemId;
                options.push({key: key, id: itemId, name: name, price: Number(price) || 0});
            });
            return options;
        },

        useReformList (row, list) {
            var options = this.buildReformOptions(list);

            this.$set(row, 'reformOptions', options || []);
            this.$set(row, 'reformChecked', []);
            //选中的改制要求(多选,逗号拼接)
            this.$set(row, 'specificReform', '');
            this.$set(row, 'reformMaterialId', '');
            //单台加价:所选改制要求的加价累加值(存放在extraPrice)
            this.$set(row, 'extraPrice', '0.00');

        },
        //勾选改制要求后重新计算:记录选中的改制要求,并累加各要求的单台加价
        calcReformPrice (row, checked) {
            if (!row) {
                return '0.00';
            }
            var selected = Array.isArray(checked) ? checked : (row.reformChecked || []);
            var names = [];
            var ids = [];
            var total = new big(0);
            (row.reformOptions || []).forEach((opt) => {
                if (selected.indexOf(opt.key) >= 0) {
                    names.push(opt.name);
                    if (opt.id != null) {
                        ids.push(opt.id);
                    }
                    total = total.plus(opt.price || 0);
                }
            });
            //新字段:选中的改制要求
            row.specificReform = names.join(',');
            //选中的改制要求id(提交订单时传给后台,逗号拼接)
            row.reformMaterialId = ids.join(',');
            //单台加价:每个选中改制要求的加价累加(存放在extraPrice)
            row.extraPrice = total.toFixed(2);
            //单台加价变更后同步成交价:成交价 = 成交价 + 单台加价
            this.calcFinalPrice(row);
            //成交价变化后联动净价值与总价
            this.calcNetWorth(row);
            this.calcTotalPrice(row);
            return row.extraPrice;
        },


        //加载产品图片:数据来源为 imageUrls
        loadProductImage (row) {
            if (!row) {
                return;
            }

            //1.行数据本身已带 imageUrls(物料数据自带或订单回显),直接用
            var ownUrls = this.normalizeImageUrls(row.imageUrls);
            if (ownUrls.length > 0) {
                this.productImageCache[row.materialCode] = ownUrls;
                this.$set(row, 'imageUrls', ownUrls);
                this.loadPreviewImages(row, ownUrls);
                return;
            }

            if (!row.materialCode) {
                this.$set(row, 'imageUrls', []);
                return;
            }

            //2.命中缓存直接使用,避免重复请求
            if (this.productImageCache[row.materialCode]) {
                var cached = this.productImageCache[row.materialCode];
                this.$set(row, 'imageUrls', cached);
                this.loadPreviewImages(row, cached);
                return;
            }

            //3.按物料编码查询接口,取返回数据里的 imageUrls
            this.$set(row, 'imageUrls', []);
            reformToMaterial.queryProductImageByBeCode({materialCode:row.materialCode}).then(rd => {
                var imageUrls = this.normalizeImageUrls(rd && rd.obj ? rd.obj.imageUrls : null);
                console.log("产品图片", row.materialCode, JSON.stringify(imageUrls))
                this.productImageCache[row.materialCode] = imageUrls;
                this.$set(row, 'imageUrls', imageUrls);
                //预取预览用本地 blob
                this.loadPreviewImages(row, imageUrls);
            }).catch(() => {
                this.productImageCache[row.materialCode] = [];
                this.$set(row, 'imageUrls', []);
            });
        },
        //图片地址处理:完整地址直接用,相对地址拼接接口服务地址
        formatProductImage (url) {
            if (!url) {
                return '';
            }
            //去除首尾空白与零宽字符,避免拼出不可访问的地址
            url = String(url).trim().replace(/[\u200b\u200c\u200d\ufeff]/g, '');
            if (/^https?:\/\//i.test(url)) {
                return url;
            }
            return window.location.protocol + '//' + process.env.VUE_APP_AJAXURL + '/' + url.replace(/^\/+/, '');
        },
        //预取大图预览用的本地 blob:el-image-viewer 内部 img 不支持 referrerpolicy,OSS 防盗链会拦截
        loadPreviewImages (row, urls) {
            if (!urls || urls.length == 0) {
                return;
            }
            const previewUrls = urls.slice();
            Promise.all(urls.map((url, i) => {
                return fetch(url, { referrerPolicy: 'no-referrer' })
                    .then((res) => {
                        if (!res.ok) {
                            return null;
                        }
                        return res.blob();
                    })
                    .then((blob) => {
                        if (blob) {
                            previewUrls[i] = URL.createObjectURL(blob);
                        }
                    })
                    .catch(() => {});
            })).then(() => {
                this.$set(row, 'previewImageUrls', previewUrls);
            });
        },
        //产品图片加载失败日志,便于定位问题
        onProductImageError (e) {
            console.log('产品图片加载失败:', e && e.target ? e.target.src : e);
        },
        //订单数量输入过滤:只保留数字、最多两位小数(等价原表格列上的 oninput)
        onProductNumberInput (row) {
            if (!row) {
                return;
            }
            var v = row.proNumber == null ? '' : String(row.proNumber);
            row.proNumber = v.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
        },
        //成交价:与原表格列同口径(赋值到 row.finalPrice,提交逻辑依赖该字段)
        //成交价 = 特价/基准价(含折扣) + 加价(定制加价与改制单台加价统一存放在extraPrice,只加一次)
        calcFinalPrice (row) {
            if (!row) {
                return '0.00';
            }
            row.finalPrice = new big(row.specialPrice || row.expoPrice ||
                row.proBenchmarkPrice * row.discount ||
                row.proBenchmarkPrice).plus(row.extraPrice || 0).toFixed(2).toString();
            return row.finalPrice;
        },
        //净价值:成交价/税率(与原表格列同口径)
        calcNetWorth (row) {
            if (!row) {
                return '0.00';
            }
            var finalPrice = row.finalPrice || this.calcFinalPrice(row);
            row.jinejjz = new big(finalPrice || 0).div(row.taxRate || 1).toFixed(2).toString();
            return row.jinejjz;
        },
        //总价:订单数量 * 成交价(与原表格列同口径)
        calcTotalPrice (row) {
            if (!row) {
                return '0.00';
            }
            var finalPrice = row.finalPrice || this.calcFinalPrice(row);
            row.totalprice = new big(row.proNumber || 0).times((finalPrice || 0)).toFixed(2).toString();
            return row.totalprice;
        },

        //点击产品卡片切换当前查看行(卡片高亮)
        selectProductRow (row) {
            if (!row) {
                return;
            }
            this.currentRowId = row.id;
        },
        //切换某张产品卡片自己的图片下标
        selectProductImage (row, i) {
            if (!row) {
                return;
            }
            this.$set(row, 'imageIndex', i);
        },
        //当前查看的产品行:优先取点击的行,没有则默认第一行
        getCurrentProduct (code) {
            var list = this['productlist' + code] || [];
            if (list.length == 0) {
                return {};
            }
            var hit = null;
            for (var i = 0; i < list.length; i++) {
                if (list[i].id == this.currentRowId) {
                    hit = list[i];
                    break;
                }
            }
            return hit || list[0];
        },
        wlToProject (obj) {
            var wl = {};
            wl.id = this.$util.getUuid();
            wl.materialCode = obj.matecode;//物料编码
            wl.materialName = obj.matedes;//物料名称
            wl.proModelCode = obj.cpdlcode;//产品型号编码
            wl.proModelName = obj.cpdlname;//产品型号名称
            wl.cpz = obj.cpz; //产品组
            wl.dwcode = obj.dwcode;//单位
            wl.dwname = obj.dwname;//单位
            wl.currencyCode = obj.currency;//币种编码
            if (obj.taxCat != null && obj.taxCat != '') {
                wl.taxCat = obj.taxCat;//税分类
            } else {
                this.$msg.msge("税分类不能为空！");
                return;
            }
            wl.field = obj.field;//选择产品所在的领域
            wl.orderField = obj.field;//选择产品所在的领域
            //税率
            if (wl.taxCat == '2' || wl.taxCat == '3' || wl.taxCat == '4') {
                wl.taxRate = 1.13;
            } else if (wl.taxCat == '7') {
                wl.taxRate = 1.06;
            } else {
                wl.taxRate = 1;
            }

            wl.proNumber = 0;//产品数量
            wl.proBenchmarkPrice = obj.jizhj;//产品基准价
            wl.specialOfferCode = null; // 特价版本
            wl.specialPrice = null; // 特价价格
            wl.specialPriceNum = null; // 特价价格
            wl.tjid = null; // 特价id
            wl.tjdtid = null; // 特价蛋疼id
            wl.isCustommed = 0; // 是否定制     1：是   0 否
            wl.extraPrice = null; // 定制加价
            wl.extraDes = null; // 定制需求
            wl.cwddh = null;
            //211220 公司代码根据销售样表来
            if (obj.companycode == '1D90') {
                //物料销售公司是海乐苗，代理商签约1D90但未签约1RK0,则销售组织是1D90
                if (this.companycodes.indexOf('1D90') != -1 && this.companycodes.indexOf('1RK0') == -1) {
                    wl.gscode = '1D90';
                } else if ((this.companycodes.indexOf('1D90') != -1 && this.companycodes.indexOf('1RK0') != -1)
                    || (this.companycodes.indexOf('1D90') == -1 && this.companycodes.indexOf('1RK0') != -1)) {
                    //物料销售公司是海乐苗，未签约1D90但签约1RK0或1D90和1RK0都签约了，销售公司是1RK0
                    wl.gscode = '1RK0';
                } else {
                    wl.gscode = obj.companycode; //公司编码
                }
            } else {
                wl.gscode = obj.companycode; //公司编码
            }
            //如果是厚宏的代理商下单,默认公司1S00
            if(this.hhdls && (obj.factory == '9393' || obj.factory == '9370' || obj.factory == '1RK0'
                || obj.factory == '1JC0' || obj.factory == '1S00' || obj.factory == '1S40')
            ){
                //这里取hhpt配置表
                wl.gscode = this.hhGsCode;
                this.order.hhdls = this.hhType;
            }else {
                this.order.hhdls = '0'
                this.hhdls = false;
            }

            wl.proType = obj.protype; //自产还是oem
            wl.cgprice = obj.cgprice; //采购价
            wl.cgmll = obj.cgmll; //采购毛利率
            wl.shareModelCode = null;
            wl.shareModelName = null;

            wl.finalPrice = 0;//成交价
            //如果是二级经销商 基准价*1.07 (暂只考虑标准订单) hyl
            if (wl.gscode == '9390' || wl.gscode == '9370' || wl.gscode == '1RK0') {
                if (this.agentLevel == 2) {
                    wl.proBenchmarkPrice = new big(wl.proBenchmarkPrice).times(1.07).toFixed(2).toString()
                }
            }


            wl.totalprice = 0;//产品总价
            wl.tjlist = obj.tjlist;//特价list
            wl.expoPrice = obj.expoPrice;
            wl.fromtype = obj.fromtype;

            //2021,12,28 zk 新增共享大类list
            wl.smList = obj.smList;

            wl.factory = obj.factory;

            wl.cpdlcode = obj.cpdlcode;

            wl.xiaoe = obj.xiaoe;
            wl.jishu = obj.jishu;
            wl.lianqun = obj.lianqun;
            wl.oemDesc = obj.oemDesc;
            wl.isXietong = 0;

            wl.tianman = false;
            if(this.guanliren&&wl.proType=='OEM'){
                //根据产品种类判断是不是直发,如果产品层级
                if(obj.productHierarchy != null && obj.productHierarchy != ''){
                    if(obj.productHierarchy.includes("YX1E33") || obj.productHierarchy.includes("YX1J26") ||obj.productHierarchy.includes("YX1J27")){
                        wl.zhifakufa = 2
                        wl.tianman = true;
                    }else {
                        wl.zhifakufa = 2
                    }
                }else {
                    wl.zhifakufa = 2
                }
            }
            //如果1S00公司
            if ((obj.companycode == '1S00') && this.hhxmList.length == 0 ) {
                this.isHh = true;
                //查询厚宏项目合同
                ss.contractService.getHhxmContract(this.order.soldToCode).then(rd => {
                    this.hhxmList = rd.msg;
                })
            }
            return wl;
        },
        //选择地址
        selectAreadialog () {
            this.showdizhiflag = true;
        },
        choseDizhi (obj) {

            console.log("选中的地址", obj)
            this.order.addressCode = obj.id;
            this.order.areaId = obj.id;
            this.order.toAddress = obj.quobj.namepath;
            if (obj.zhenobj) {
                // this.order.toAddress = obj.zhenobj.namepath;
                obj.addrdetail = obj.zhenobj.name + "/" + obj.addrdetail;
            }
            this.order.toAddress = this.order.toAddress + "##" + obj.addrdetail

            this.order.toProvincesCode = obj.shengobj.code;
            this.order.toProvincesName = obj.shengobj.name;

            this.order.toCityCode = obj.shiobj.code;
            this.order.toCityName = obj.shiobj.name;

            this.showdizhiflag = false;


            //清空时间
            this.order.receivedTime = null;
            this.openReceivedTimedisabled = false;
            //根据地址，获取预计收货时间
            // ss.OrderMainService.getSendDays(obj.qu).then(rd => {
            //     console.log(rd);
            //     this.startDateLimit = _.assign({}, this.startDateLimit, {
            //         disabledDate: (time) => {
            //             return time.getTime() < new big(rd).plus(2).times(24 * 60 * 60 * 1000).plus(Date.now()).toString()
            //         }
            //     })
            // })
        },

        //直单用户修改公司 hyl
        chooseGsCode (code) {
            //将其他公司的数据赋值给选择的公司
            this.companyInfoList.forEach((obj) => {
                if (obj.code != code) {
                    this['productlist' + obj.code].forEach((obj) => {
                        this['productlist' + code].push(obj);
                    })
                    //清空其他公司信息
                    this['productlist' + obj.code] = [];
                }
            })
            //将所有物料的公司编码改成选择的
            for (var i = 0; i < this['productlist' + code].length; i++) {
                this['productlist' + code][i].gscode = code;
            }
            this.getCredit(code);
            //公司切换后表格数据重组,当前查看项回退到第一行
            var list = this['productlist' + code] || [];
            this.currentRowId = list.length > 0 ? list[0].id : null;
        },
        //获取收货单位
        showFormList (value) {
            // console.log("value188776676","111111111111111111111111")
            var data = value;
            console.log("value188776676", data)
            /**
             * 如果是经销商2.0（二级代理商）收货单位需是一级经销商对阵的用户,
             **/
            if (this.agentLevel == 2 && !this.xiaoshouCompany) {
                ss.grabOrderApi.getDistributor2toUser(this.order.soldToCode, value).then(rd => {
                    this.addrList = rd;
                })
            } else {
                ss.OrderMainService.getCompanyInfo(value).then(rd => {
                    this.addrList = rd;
                })
            }



        },

        isStandardChange () {
            if (this.order.isStandard == 2) {
                this.$message('请上传投标参数及海尔配置清单');
            } else if (this.order.isStandard == 1) {
                this.$message('请上传海尔配置清单');
            }
        },

        //新增收货单位
        createAddress () {
            this.titleDig = "新建收货单位"
            this.institutionalX = true
            /*this.loadArea();*/
        },
        closeCompanyName (propData) {
            console.log(propData);
            this.closeDialog();
        },
        loadArea (i) {
            ss.Dictservice.arealist(this.proSelect).then(rd => {
                this.shenglist = rd;
                // for(let i = 0; i < this.shenglist.length; i++){
                //     this.shenglist[i].code = this.shenglist[i].code.substring(0,6);
                // }
                console.log("shenglist", this.shenglist)
            })
        },
        //取消
        exit () {
            this.closeDialog()
        },
        //关闭弹窗,清空数据
        closeDialog () {
            this.institutionalX = false
            this.newDialog = false
            this.updateDialog = false
            this.insertFlag = false
            this.reFlag = false
            //清空数据
            this.add.deptName = '';
            this.add.deptType = '';
            this.add.phone = '';
            this.add.leader = '';
            this.add.email = '';
            this.add.province = '';
            this.add.provinceId = '';
            this.add.city = '';
            this.add.cityId = '';
            this.add.landmark = '';
            this.add.area = '';
            this.add.areaId = '';
            this.add.address = '';
            this.add.parentCode = '';
            this.add.deptSourceChannel = '';
            this.stVal = null;
            this.add.schoolTypeName = '';
        },
        //省份选择器
        handleItemChange1 (o) {
            this.add.provinceId = o;
            this.address = _.find(this.shenglist, { code: this.add.provinceId });
            this.add.province = this.address.name;
            ss.Dictservice.areaTreelist({ code: o }).then(rd => {
                console.log("rddddddd", rd.zlist)
                this.add.city = '';
                this.add.area = '';
                this.arealist2 = rd.zlist;
                this.arealist3 = [];
            })
        },
        handleItemChange2 (o) {
            this.add.cityId = o;
            this.address = _.find(this.arealist2, { code: this.add.cityId });
            this.add.city = this.address.name;
            this.arealist3 = _.find(this.arealist2, { code: o }).zlist
            console.log("arealist3", this.arealist3)
            this.arealist4 = []
        },
        handleItemChange3 (o) {
            this.add.areaId = o;
            this.address = _.find(this.arealist3, { code: this.add.areaId });
            this.add.area = this.address.name;
        },
        commitCreate (v) {
            this.add.subFlag = '提交';
            this.add.countryId = '156';
            this.add.country = '中国';
            this.add.provinceId = this.add.provinceId.substring(0, 6);
            this.add.cityId = this.add.cityId.substring(0, 6);
            this.add.areaId = this.add.areaId.substring(0, 6);
            this.add.parentCode = this.stVal;

            var data = this.add;
            ss.nxAddress.insertAddress(data).then(rd => {
                this.closeDialog();
                this.query();
            })
        },
        //获取单位名称信息
        selectDept (value) {
            ss.nxAddress.getDeptList(value).then(rd => {
                this.deptNameList = rd.msg;
            })
        },
        //获取当前登录人创建的所有父级单位
        getParentInfo () {
            ss.nxAddress.getParentInfo().then(rd => {
                this.options = rd.msg;
            })
        },
        httpRequest2 (params) {
            console.log(params, "1111111111")
            const loading = this.$msg.loading("上传中...");
            uploadFile.upload(params.file, { companycode: this.testID, reftype: this.reftype2 }).then(rd => {
                console.log("上传完毕后", rd);
                loading.close();
                this.fileList2.unshift(rd.obj);
                this.idList.push(rd.obj.id);
                this.order.upload2.unshift("1");
            }).catch(error => {
                loading.close();
                this.fileList2.splice(0, 1);
                return Promise.reject(error);
            });
            return false;
        },
        handleRemove2 (file) {
            console.log(file, "aaaaa");
            //删除文件
            var id = file.id;
            uploadFile.deleteById(id).then(response => {
                // console.log(response,"删除")
            })
            //删除fileList数据
            // console.log(this.fileList);
            for (var i = 0; i < this.fileList2.length; i++) {
                if (this.fileList2[i].id === id) {
                    this.fileList2.splice(i, 1);
                    // console.log(this.fileList)
                }
            }
        },
        beforeRemove (file) {
            if (file && file.status === "success") {
                return this.$confirm(`确定移除 ${file.name}？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                });
            }
        },
        beforeUpload (file) {
            const isFile = file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/jpeg';
            if (!isFile) {
                this.$message.error('上传文件的格式只能是 JPG或PNG格式!');
                return false;
            }
        },
        getSchoolType () {
            for (var i = 0; i < this.addrList.length; i++) {
                var address = this.addrList[i];
                if (address.deptName == this.order.toCompanyname) {
                    if (address.schoolTypeName != null && address.schoolTypeName != '') {
                        this.showCollage = true;
                    } else {
                        this.showCollage = false;
                    }
                }
            }
        },
        //渠道改变
        changeChannel (value) {
            console.log("value", value)
            ss.nxAddress.getAddressTypeByChannel(value.code).then(rd => {
                this.addressTypeList = rd.msg;
                this.add.schoolTypeName = '';
            })
        },
        changeSchoolType (value) {
            this.add.schoolTypeName = value;
        },
        //根据公司编码返回productlist
        getProductlist (code) {
            // console.log("productlist" + code, this[`${'productlist' + code}`].length)
            return this['productlist' + code];
        },
        //根据公司编码返回OrderName
        getOrderName (code) {
            return this['order' + code];
        },
        changeDeptName (val) {
            console.log("changeDeptName", val)
            //匹配省市区信息
            ss.nxAddress.getAddressByWl(val).then(rd => {
                if (rd.f == true) {
                    this.add.provinceId = rd.msg.provinceId;
                    this.add.province = rd.msg.province;
                    this.add.cityId = rd.msg.cityId;
                    this.add.city = rd.msg.city;
                    this.add.areaId = rd.msg.areaId;
                    this.add.area = rd.msg.area;
                    this.add.address = rd.msg.address;
                    this.handleItemChangeN(this.add.provinceId);
                }
            })
            //根据单位名称获取关键字
            ss.nxAddressKeywords.matchKeywords(this.add.deptName).then(rd => {
                if (rd.msg != null) {
                    this.add.deptSourceChannel = rd.msg.channelCode;
                    this.add.schoolTypeName = rd.msg.userUnit;
                    this.matchChannel(rd.msg.channelCode)
                }
            })
        },
        matchChannel (value) {
            console.log("value", value)
            ss.nxAddress.getAddressTypeByChannel(value).then(rd => {
                this.addressTypeList = rd.msg;
                // this.add.schoolTypeName = '';
            })
        },
        //地址选择器-新
        handleItemChangeN (o) {
            this.address = _.find(this.shenglist, { code: this.add.provinceId });
            // this.add.province = this.address.name;
            ss.Dictservice.areaTreelist({ code: o }).then(rd => {
                this.arealist2 = rd.zlist;
                this.arealist3 = [];
                this.address = _.find(this.arealist2, { code: this.add.cityId });
                // this.add.city = this.address.name;
                this.arealist3 = _.find(this.arealist2, { code: o }).zlist
            })
        },
        changeHhxmCode (value) {
            if (value == null || value == "") {
                this.isHHxm = false;
            } else {
                this.isHHxm = true;
            }
        },
        change44U0finalPrice (row) {
            row.proBenchmarkPrice = row.finalPrice;
        },
    }
}
</script>
<style scoped>
.queren {
    background-color: #006aca;
    color: white;
}

.anniu {
    display: flex;
    justify-content: center;
    align-items: center;
}

.zancun {
    background-color: #24b5b8;
    color: white;
}

.quxiao,
.zancun {
    width: 100px;
}

.jieguo {
    border-bottom: 1px solid rgb(238, 236, 236);
    display: flex;
}

.jieguo .jieguo_label {
    width: 2rem;
    text-align: right;
    background-color: #ebf5ff;
    font-size: 0.16rem;
    color: #616467;
    height: 0.4rem;
    line-height: 0.4rem;
    padding: 0 0.05rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.jieguo .jieguo_value {
    width: 19%;
    font-size: 0.16rem;
    color: #616467;
    height: 0.4rem;
    line-height: 0.4rem;
    padding: 0px 8px;
}

img {
    width: 25px;
    padding: 5px 0;
}

.DshuR {
    width: 100%;
    height: 100%;
    border: none;
}

/*=========== 卡片式布局:订单信息/客户信息/产品详情/产品图片/改制选项 ===========*/
.nx-page {
    padding-bottom: 10px;
}

.nx-card {
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}

.nx-card-title {
    display: flex;
    align-items: center;
    padding: 12px 16px 8px;
    font-size: 15px;
    font-weight: 600;
    color: #1f2d3d;
}

.nx-card-bar {
    width: 4px;
    height: 15px;
    margin-right: 8px;
    border-radius: 2px;
    background: #409EFF;
}

.nx-card-body {
    padding: 0 16px 14px;
}

.nx-title-right {
    display: flex;
    align-items: center;
    margin-left: auto;
    font-size: 13px;
    font-weight: 400;
    color: #606266;
}

.nx-title-right .nx-company {
    margin-right: 10px;
    color: #909399;
}

/*两栏布局:左=客户信息/产品详情,右=产品图片/改制选项
  同一行的两张卡片等高(底部对齐),内容少的卡片自然被撑到与另一张齐平*/
.nx-layout {
    display: grid;
    grid-template-columns: 1.2fr 1fr;
    gap: 0 14px;
    align-items: stretch;
}

/*改制选项:内容少时保持自然高度,不跟着产品详情拉高*/
.nx-self-start {
    align-self: start;
}

.nx-cell {
    margin-bottom: 14px;
}

.nx-full {
    grid-column: 1 / -1;
    margin-bottom: 14px;
}

/*字段栅格*/
.nx-grid {
    display: grid;
    gap: 0 16px;
}

.nx-grid-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
}

.nx-grid-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
}

.nx-grid > .nx-span-2 {
    grid-column: span 2;
}

/*表单:标签在上,控件在下*/
.nx-form ::v-deep .el-form-item {
    margin-bottom: 12px;
}

.nx-form ::v-deep .el-form-item .el-form-item__label {
    padding: 0 0 4px;
    line-height: 20px;
    font-size: 13px;
    color: #606266;
    text-align: left;
}

.nx-form ::v-deep .el-form-item .el-form-item__content {
    line-height: normal;
}

.nx-form ::v-deep .el-form-item .el-form-item__content .el-input,
.nx-form ::v-deep .el-form-item .el-form-item__content .el-select,
.nx-form ::v-deep .el-form-item .el-form-item__content .el-date-editor {
    width: 100%;
}

/*附件类字段:标签与上传按钮同一行*/
.nx-form ::v-deep .el-form-item.nx-inline {
    display: flex;
    align-items: center;
}

.nx-form ::v-deep .el-form-item.nx-inline .el-form-item__label {
    width: auto;
    padding: 0 8px 0 0;
}

.nx-form ::v-deep .el-form-item.nx-inline .el-form-item__content {
    flex: 1;
    min-width: 0;
}

/*收货单位后面的新增图标*/
.nx-field-with-icon {
    position: relative;
}

.nx-field-with-icon .nx-add-icon {
    position: absolute;
    right: 6px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 16px;
    color: #409EFF;
    cursor: pointer;
}

/*单台加价:红色;总价:蓝色*/
.nx-form ::v-deep .nx-input-reform .el-input__inner {
    color: #f56c6c;
    font-weight: 500;
}

.nx-form ::v-deep .nx-input-total .el-input__inner {
    color: #409EFF;
    font-weight: 500;
}

/*改制选项:两列复选框*/
.nx-reform-group {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 6px 12px;
}

.nx-reform-group .el-checkbox {
    margin: 0;
}

/*空状态提示*/
.nx-empty {
    padding: 24px 0;
    font-size: 13px;
    color: #909399;
    text-align: center;
}

.reform-opt-price {
    margin-left: 2px;
    color: #f56c6c;
}

/*产品图片:图片序号计数与底部计数行*/
.panel-count {
    font-size: 12px;
    color: #909399;
}

.panel-foot {
    display: flex;
    justify-content: flex-end;
    padding-top: 8px;
}

.panel-main {
    position: relative;
    height: 300px;
    background: #f5f7fa;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
}

.panel-image {
    width: 100%;
    height: 100%;
}

.panel-tag {
    position: absolute;
    left: 8px;
    bottom: 8px;
    padding: 2px 6px;
    font-size: 12px;
    line-height: 16px;
    color: #fff;
    background: rgba(0, 0, 0, 0.45);
    border-radius: 2px;
}

.panel-main-empty {
    flex-direction: column;
    font-size: 12px;
    color: #c0c4cc;
}

.panel-main-empty i {
    font-size: 28px;
    margin-bottom: 6px;
}

.panel-thumbs {
    display: flex;
    flex-wrap: wrap;
    padding-top: 10px;
}

.panel-thumb {
    width: 56px;
    height: 46px;
    margin: 0 8px 8px 0;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;
}

.panel-thumb.active {
    border-color: #409EFF;
}

.panel-thumb-img {
    width: 100%;
    height: 100%;
}
</style>
<style>
.w-newIcon .el-input__icon {
    line-height: 0.4rem !important;
}
/*产品图片大图预览层,避免被页面其他浮层遮挡*/
.el-image-viewer__wrapper {
    z-index: 9999999 !important;
}
/*产品图片:el-image 内部 img 撑满容器(内部元素 scoped 样式覆盖不到,需全局样式)*/
.panel-image .el-image__inner,
.panel-thumb-img .el-image__inner {
    width: 100%;
    height: 100%;
}

</style>
<style scoped lang="scss">
.bottomTip {
    position: absolute;
    left: 49.7%;
    bottom: 0.3rem;
    transform: translateX(-50%);
    z-index: 999999;
}

.newtext {
    font-size: 0.28rem;
    color: white;
    position: absolute;
    top: 0.2rem;
    left: 50%;
    transform: translateX(-50%);
    font-weight: bold;
    text-shadow: 1px 1px 4px #2785e7;
    z-index: 2;
}

.leaderBox {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    position: fixed;
    z-index: 99999;
    overflow: hidden;
    top: 0;
    left: 0;

    .leaderbg {
        width: 100%;
        height: 100%;
    }

    .createNxs {
        position: absolute;
        z-index: 1;
    }

    .createNx1 {
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .createNxbtn {
        width: 1.9rem;
        height: 0.6rem;
        border: 0.03rem solid #ffffff;
        background-color: rgba(0, 0, 0, 0.1);
        border-radius: 5px;
        display: flex;
        justify-content: center;
        line-height: 0.5rem;
        position: absolute;
        z-index: 99;
        bottom: 0.75rem;
        left: 50%;
        transform: translateX(-50%);
        font-size: 0.27rem;
        letter-spacing: 2px;
        color: white;
        cursor: pointer;
    }


}
</style>
